import type { AthleteProfile as CentralAthleteProfile } from "../../athlete-profile/types/athleteProfile";
import type { AthleteProfile } from "../types/garage";

export function mapToGarageAthleteProfile(profile: CentralAthleteProfile): AthleteProfile {
  return {
    id: profile.personal.id,
    name: `${profile.personal.firstName} ${profile.personal.lastName}`.trim(),
    heightCm: Math.round(profile.personal.heightInches * 2.54),
    weightKg: Number((profile.personal.currentWeightLb * 0.45359237).toFixed(1)),
      ftpWatts: profile.performance.gravelFtpWatts ?? profile.performance.ftpWatts,
    restingHeartRateBpm: profile.performance.restingHeartRateBpm,
    maxHeartRateBpm: profile.performance.maxHeartRateBpm,
    powerZones: profile.performance.powerZones,
    heartRateZones: profile.performance.heartRateZones,
    nutritionPreferences: {
      preferredFuelType: "mix",
      carbTargetPerHour: [profile.nutrition.preferredRideCarbsPerHour - 5, profile.nutrition.preferredRideCarbsPerHour + 5],
      hydrationOzPerHour: [
        Math.round((profile.nutrition.preferredFluidsMlPerHour / 29.5735) - 2),
        Math.round((profile.nutrition.preferredFluidsMlPerHour / 29.5735) + 2)
      ],
      sodiumMgPerHour: [profile.nutrition.preferredSodiumMgPerHour - 100, profile.nutrition.preferredSodiumMgPerHour + 100],
      dietaryNotes: profile.nutrition.nutritionNotes ? [profile.nutrition.nutritionNotes] : []
    },
    recoveryPreferences: {
      preferredColdTime: profile.recovery.morningColdPlungeTiming === "evening" ? "evening" : "morning",
      preferredHeatTime: "evening",
      mobilityMinutesTarget: 15,
      sleepHoursTarget: profile.recovery.preferredSleepHours
    }
  };
}
